import React from 'react';

class SearchTab extends React.Component {
    state = { term: '', year:'',venue:'',session:''};

    onInputChange = () => {
        if(this.state.year!=='' && this.state.venue!=='' && this.state.session!==''){
            this.props.runWhenSubmited(this.state.year, this.state.venue, this.state.session);
         //   console.log("Full Search: " + this.state.year +" " + this.state.venue +" " + this.state.session);
        }
    };

    onYearChange = (event)=>{
        this.setState({ year: event.target.value }, function () {
            //callback used to give state time to update
            console.log("Year Value: " + this.state.year);
         //   console.log("Full Search: " + this.state.year +" " + this.state.venue +" " + this.state.session);
            this.onInputChange();
        });
    }

    onVenueChange = (event)=>{
        this.setState({ venue: event.target.value }, function () {
            //callback used to give state time to update
            console.log("Venue Value: " + this.state.venue);
            this.onInputChange();
        });
    }

    onSessionChange = (event)=>{
        this.setState({ session: event.target.value }, function () {
            //callback used to give state time to update
            console.log("Session Value: " + this.state.session);
            this.onInputChange();
        });
    }

    render() {
        return (
                    <div className="field">
                        <select className="ui dropdown" value={this.state.year} onChange={this.onYearChange}>
                            <option value="">Year</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                            <option value="2019">2019</option>
                        </select>
                        <select className="ui dropdown" value={this.state.venue} onChange={this.onVenueChange}>
                            <option value="">Venue</option>
                            <option value="Bahrain Grand Prix">Bahrain GP</option>
                            <option value="Saudi Arabian Grand Prix">Saudi Arabian GP</option>
                            <option value="Australian Grand Prix">Australian GP</option>
                            <option value="Gran Premio Dell Emilia Romagna">Emilia Romagna GP</option>
                            <option value="Miami Grand Prix">Miami GP</option>
                            <option value="Gran Premio De Espana">Spanish GP</option>
                            <option value="Grand Prix De Monaco">Monaco GP</option>
                            <option value="Azerbaijan Grand Prix">Azerbaijan GP</option>
                            <option value="Grand Prix Du Canada">Canadian GP</option>
                            <option value="British Grand Prix">British GP</option>
                            <option value="Austrian Grand Prix">Australian GP</option>
                            <option value="Grand Prix De France">French GP</option>
                            <option value="Magyar Nagydij Hungary Grand Prix">Hungary GP</option>
                            <option value="Rolex Belgian Grand Prix">Belgian GP</option>
                            <option value="Heineken Dutch Grand Prix">Dutch GP</option>
                            <option value="Gran Premio Italian Grand Prix">Italian GP</option>
                            <option value="Singapore Grand Prix">Singapore GP</option>
                            <option value="Japanese Grand Prix">Japanese GP</option>
                            <option value="Austin United States Grand Prix">Austin GP</option>
                            <option value="Mexican Grand Prix">Mexican GP</option>
                            <option value="Brazilian Grand Prix">Brazilian GP</option>
                            <option value="Abu Dhabi Grand Prix">Abu Dhabi GP</option>
                        </select>
                        <select className="ui dropdown" value={this.state.session} onChange={this.onSessionChange}>
                            <option value="">Session Type</option>
                            <option value="Race">Race</option>
                            <option value="Qualifying">Qualifying</option>
                            <option value="Sprint Qualifying">Sprint Qualifying</option>
                            <option value="FP3">Free Practice 3</option>
                            <option value="FP2">Free Practice 2</option>
                            <option value="FP1">Free Practice 1</option>
                        </select>
                    </div>
        );
    }
}

export default SearchTab;